<div #callsContainer class="calls-container">
  @let showOnlyToBeJoinedCalls = showOnlyToBeJoinedCalls$ | async;
  @if (useGroupingByDate && callListType === 'upcoming') {
    <div class="all-calls-toggle-container">
      <mat-slide-toggle
        [ngModel]="showOnlyToBeJoinedCalls"
        (ngModelChange)="toggleShowOnlyToBeJoinedCalls($event)"
        labelPosition="before"
        class="filter-toggle"
        [matTooltip]="'CALLS.UPCOMING_MEETING.FILTER_TOOLTIP' | translate"
      >
        <span class="filter-label">
          {{ 'CALLS.BRIEF_ENABLED' | translate }}
        </span>
      </mat-slide-toggle>
    </div>
  }

  @if (useGroupingByDate) {
    @if (callListType === 'upcoming') {
      @if (ongoingCalls$ | async; as ongoingCalls) {
        @if (ongoingCalls.length > 0) {
          <div class="header-with-filter">
            <h2 class="date-group">{{ 'CALLS.ONGOING' | translate }}</h2>
          </div>
          <div class="calls">
            @for (call of ongoingCalls; track call.id) {
              <div class="ongoing-call">
                <app-ongoing-meeting-card [call]="call" [isExpanded]="true" [useHighlight]="true" [attr.data-call-id]="call.id"></app-ongoing-meeting-card>
              </div>
            }
          </div>
        }
      }
    }
    @for (callGroup of (filteredGroupedCalls$ | async) ?? []; track callGroup.date; let isFirst = $first) {
      @if (isFirst && callListType === 'upcoming') {
        <h2 class="date-group">{{ callGroup.date }}</h2>
      } @else {
        <h2 class="date-group">{{ callGroup.date }}</h2>
      }
      <div class="calls">
        @for (call of callGroup.calls; track call.id) {
          <div waIntersectionObserver waIntersectionThreshold="0.5" (waIntersectionObservee)="onCallVisible($event, call)">
            @if (callListType === 'past') {
              <app-previous-meeting-card
                [call]="call"
                [activeMatch]="activeMatch"
                [isActive]="activeCall !== null && activeCall.id === call.id"
                (mouseenter)="hoverCall.emit(call)"
                [attr.data-call-id]="call.id"
              ></app-previous-meeting-card>
            } @else if (callListType === 'upcoming') {
              <app-upcoming-meeting-card [call]="call" [attr.data-call-id]="call.id"></app-upcoming-meeting-card>
            }
          </div>
        }
      </div>
    } @empty {
      @if (callListType === 'past') {
        <p class="no-matching-calls" translate="CALLS.NO_CALLS_PAST"></p>
      } @else if (callListType === 'upcoming') {
        <p class="no-matching-calls" translate="CALLS.NO_CALLS_UPCOMING"></p>
      }
    }
  } @else {
    <div class="calls">
      @for (call of calls; track call.id) {
        @if (callListType === 'past') {
          <app-previous-meeting-card
            [call]="call"
            [activeMatch]="activeMatch"
            [isActive]="activeCall !== null && activeCall.id === call.id"
            [useCompactMode]="true"
            (mouseenter)="hoverCall.emit(call)"
            [attr.data-call-id]="call.id"
          ></app-previous-meeting-card>
        } @else if (callListType === 'upcoming') {
          <app-upcoming-meeting-card [call]="call" [attr.data-call-id]="call.id"></app-upcoming-meeting-card>
        }
      }
    </div>
  }
  @if (hasMore) {
    <div class="load-more-container" waIntersectionObserver waIntersectionThreshold="0.5" (waIntersectionObservee)="loadMore()">
      @if (isFetchingNextPage) {
        <app-spinner></app-spinner>
      }
    </div>
  }
</div>
